import { createFileRoute } from '@tanstack/react-router'

import { ServiceStep } from '@/pages/create-booking-page'

export const Route = createFileRoute('/_dashboard/branch/$branchId/create/_wizard/service')({
    component: ServiceStep,
})
